var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConversationText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.993 12.725c0-2.881 2.721-5.225 6.066-5.225a6.534 6.534 0 0 1 4.425 1.657.187.187 0 0 0 .308-.09A6.185 6.185 0 0 0 18 7.5C18 3.364 13.963 0 9 0S0 3.365 0 7.5a6.778 6.778 0 0 0 2.075 4.782L1.01 15.83a.375.375 0 0 0 .511.45l4.104-1.827c.511.172 1.036.302 1.568.389a.188.188 0 0 0 .203-.262 4.535 4.535 0 0 1-.403-1.855zm.132-3.537H4.5a.563.563 0 0 1 0-1.126h2.625a.563.563 0 0 1 0 1.126zM4.5 5.812h7.875a.562.562 0 1 0 0-1.125H4.5a.563.563 0 0 0 0 1.125z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 8.625c-2.726 0-4.942 1.839-4.942 4.1 0 2.641 3.059 4.742 6.342 3.924l2.625 1.311a.375.375 0 0 0 .525-.443l-.675-2.25A3.681 3.681 0 0 0 18 12.725c0-2.261-2.216-4.1-4.94-4.1z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationText);
export default __webpack_public_path__ + "static/media/conversation-text.c0874f99f93a6b9541f4ea4704a57c3d.svg";
export { ForwardRef as ReactComponent };